import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const currentFrame = this.element.closest("turbo-frame");
    const dynamicChatFeed = document.querySelector(".feed-dynamic-container");
    const chatFeedUserId = dynamicChatFeed.dataset.userId;
    const isNativeApp = (dynamicChatFeed.dataset.nativeApp == 'true');

    if (!currentFrame) {
      return;
    }

    const prevFrame = this.findPreviousTurboFrame(currentFrame);

    if (!prevFrame) {
      return;
    }

    const currentUserId = this.element.dataset.userId;
    const prevUserId = prevFrame.querySelector(".feed-chat-message").dataset.userId;

    if (currentUserId === prevUserId) {
      this.element.classList.add("run-on");
    }

    if (currentUserId === chatFeedUserId) {
      this.element.classList.add("current-user");
      const actions = this.element.querySelector(".feed-chat-actions");
      if (actions) actions.classList.remove("hidden");
    } else {
      const actionsEl = this.element.querySelector(".feed-chat-actions");
      if (actionsEl) actionsEl.remove();
    }

    const isNewMessage = this.element.hasAttribute('data-created-now');
    const messageContainer = document.querySelector(".feed-chat");

    if (isNewMessage && !isNativeApp) {
      const nearBottom = messageContainer.scrollTop > (messageContainer.scrollHeight - messageContainer.clientHeight - 200);

      if (currentUserId === chatFeedUserId || nearBottom) {
        setTimeout(() => {
          messageContainer.scrollTop = messageContainer.scrollHeight;
        }, 100);
      }
    }

    if (isNewMessage && isNativeApp) {
      const nearBottom = window.scrollY > (document.documentElement.scrollHeight - window.innerHeight - 200);

      if (currentUserId === chatFeedUserId || nearBottom) {
        setTimeout(() => {
          window.scrollTo(0, document.documentElement.scrollHeight);
        }, 100);
      }
    }

  }

  findPreviousTurboFrame(element) {
    let previous = element.previousElementSibling;

    while (previous && previous.tagName !== "TURBO-FRAME") {
      previous = previous.previousElementSibling;
    }

    return previous;
  }
}